const weights = {
  light: 300,
  regular: 400,
  bold: 700,
  heavy: 900,
};

// Modular scale (Base: 1rem; Ratio: 1.067 minor second)
const sizes = {
  300: '0.878rem',
  400: '0.937rem',
  500: '1rem',
  600: '1.215rem',
  700: '1.383rem',
  800: '2.178rem',
  900: '2.323rem',
  950: '2.479rem',
  975: '2.645rem',
  990: '2.822rem',
};

export default {
  fontFamily: 'Lato, sans-serif',
  fontWeightLight: weights.light,
  fontWeightRegular: weights.regular,
  fontWeightMedium: weights.bold,
  fontWeightBold: weights.heavy,
  h1: {
    fontSize: sizes[990],
    fontWeight: weights.bold,
    lineHeight: 1.5,
  },
  h2: {
    fontSize: sizes[975],
    fontWeight: weights.light,
    lineHeight: 1.5,
  },
  h3: {
    fontSize: sizes[950],
    fontWeight: weights.bold,
    lineHeight: 1.5,
  },
  h4: {
    fontSize: sizes[900],
    fontWeight: weights.light,
    lineHeight: 1.5,
  },
  h5: {
    fontSize: sizes[700],
    fontWeight: weights.bold,
    lineHeight: 1.4,
  },
  h6: {
    fontSize: sizes[600],
    fontWeight: weights.bold,
    lineHeight: 1.2,
  },
  subtitle1: {
    fontSize: sizes[600],
    textTransform: 'uppercase',
    fontWeight: weights.bold,
    lineHeight: 1.2,
  },
  subtitle2: {
    fontSize: sizes[600],
    fontWeight: weights.regular,
    lineHeight: 1.2,
  },
  body1: {
    fontSize: sizes[500],
    fontWeight: weights.bold,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: sizes[500],
    fontWeight: weights.regular,
    lineHeight: 1.5,
  },
  caption: {
    fontSize: sizes[300],
    lineHeight: 1.5,
  },
  button: {
    fontSize: sizes[500],
    fontWeight: weights.bold,
  },
};
